import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { AnalyticsService } from './analytics.service';

// Angular's zone catches errors thrown inside components/templates/lifecycle
// hooks and reports them here instead of letting them reach window.onerror,
// so AnalyticsService's window 'error'/'unhandledrejection' listeners alone
// would miss them. Registering this as Angular's ErrorHandler forwards those
// errors to PostHog too (via captureError -> posthog.captureException), then
// still logs to the console as Angular's default handler would.
@Injectable()
export class PosthogErrorHandler implements ErrorHandler {
  // Injected lazily via Injector to avoid a circular DI init order between
  // ErrorHandler (created very early) and AnalyticsService.
  private injector = inject(Injector);

  handleError(error: unknown): void {
    try {
      this.injector.get(AnalyticsService).captureError(error);
    } catch {
      // Analytics not available yet — swallow, still fall through to logging.
    }
    console.error(error);
  }
}
